export default __webpack_public_path__ + "static/media/mana12.c7aee536.svg";